import Swiper from "swiper";
import { Navigation, Thumbs, EffectFade } from "swiper/modules";

document.addEventListener("DOMContentLoaded", () => {
  const sliders = document.querySelectorAll("[data-swiper-product-slider]");

  sliders.forEach((item) => {
    const main = item.querySelector("[data-swiper-main]");
    const thumbs = item.querySelector("[data-swiper-thumbs]");

    const nextEl = item.querySelector(".swiper-button-next");
    const prevEl = item.querySelector(".swiper-button-prev");

    var thumbSlider = new Swiper(thumbs, {
      spaceBetween: 0,
      slidesPerView: "auto",
      slideActiveClass: "highlighted",
      watchSlidesProgress: true,
      centeredSlides: true,
      speed: 800,
      // loop: true,
      // loopedSlides: 3,
      navigation: {
        nextEl,
        prevEl,
      },
      modules: [Navigation],
    });

    var mainSlider = new Swiper(main, {
      // loop: true,
      // loopedSlides: 3,
      // slidesPerView: 3,
      allowTouchMove: false,
      effect: "fade",
      fadeEffect: {
        crossFade: true,
      },
      speed: 800,
      thumbs: {
        swiper: thumbSlider,
      },
      navigation: {
        nextEl,
        prevEl,
      },
      modules: [Thumbs, EffectFade, Navigation],
    });

    thumbSlider.on("slideChange", () => {
      console.log("Thumb slide changed to: ", thumbSlider.realIndex);
      mainSlider.slideToLoop(thumbSlider.realIndex);
    });

    // On slide click, update the main slider and move to the clicked slide on the thumb slider
    thumbSlider.on("click", (swiper) => {
      const clickedIndex = swiper.clickedIndex;
      if (clickedIndex !== undefined) {
        mainSlider.slideToLoop(clickedIndex);
        thumbSlider.slideToLoop(clickedIndex);
      }
    });
  });
});
